import React from 'react';
import {
    Box,
    Typography,
    Paper,
    Chip,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from '@mui/material';
import { Home } from 'react-feather';
import { statusColors } from '../mockData';

const PropertyOverview = ({ properties }) => {
    return (
        <Paper
            elevation={0}
            sx={{
                borderRadius: '10px',
                border: '1px solid rgba(0, 0, 0, 0.08)',
                overflow: 'hidden',
                mb: 4
            }}
        >
            <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.08)', bgcolor: '#F9FAFB' }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                    <Home size={16} style={{ marginRight: 8 }} />
                    Property Overview
                </Typography>
            </Box>
            <TableContainer>
                <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                        <TableRow>
                            <TableCell>Property</TableCell>
                            <TableCell align="center">Total Tickets</TableCell>
                            <TableCell align="center">Open</TableCell>
                            <TableCell align="center">In Progress</TableCell>
                            <TableCell align="center">Scheduled</TableCell>
                            <TableCell align="center">Resolved</TableCell>
                            <TableCell align="center">Closed</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {properties.map((property) => (
                            <TableRow key={property.name} hover>
                                <TableCell component="th" scope="row" sx={{ fontWeight: 500 }}>
                                    {property.name}
                                </TableCell>
                                <TableCell align="center">{property.total}</TableCell>
                                <TableCell align="center">
                                    <Chip
                                        label={property.open}
                                        size="small"
                                        sx={{
                                            backgroundColor: statusColors.OPEN.bg,
                                            color: statusColors.OPEN.color,
                                            fontWeight: 600,
                                            minWidth: 30
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Chip
                                        label={property.inProgress}
                                        size="small"
                                        sx={{
                                            backgroundColor: statusColors['IN PROGRESS'].bg,
                                            color: statusColors['IN PROGRESS'].color,
                                            fontWeight: 600,
                                            minWidth: 30
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Chip
                                        label={property.scheduled}
                                        size="small"
                                        sx={{
                                            backgroundColor: statusColors.SCHEDULED?.bg || '#E0E7FF',
                                            color: statusColors.SCHEDULED?.color || '#4F46E5',
                                            fontWeight: 600,
                                            minWidth: 30
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Chip
                                        label={property.resolved}
                                        size="small"
                                        sx={{
                                            backgroundColor: statusColors.RESOLVED.bg,
                                            color: statusColors.RESOLVED.color,
                                            fontWeight: 600,
                                            minWidth: 30
                                        }}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <Chip
                                        label={property.closed}
                                        size="small"
                                        sx={{
                                            backgroundColor: statusColors.CLOSED.bg,
                                            color: statusColors.CLOSED.color,
                                            fontWeight: 600,
                                            minWidth: 30
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        {properties.length === 0 && (
                            <TableRow>
                                <TableCell colSpan={7} align="center" sx={{ py: 3 }}>
                                    <Typography variant="body2" color="textSecondary">
                                        No properties found
                                    </Typography>
                                </TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

export default PropertyOverview;